<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(materialData)="data" style="'left':' 80px';">
          {{ data.item.materialName }}/{{ data.item.materialModel?data.item.materialModel:'-' }}/{{ data.item.materialUnit }}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '140px' : field.key === 'index' ?'30px':'100px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(applyUsedNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'applyUsedNum')}}</div>
        </template>
        <template v-slot:foot(outboundNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'outboundNum')}}</div>
        </template>
        <template v-slot:foot(amountIncludingTax)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amountIncludingTax')}}</div>
        </template>
        <template v-slot:foot(amountExcludingTax)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amountExcludingTax')}}</div>
        </template>
        <template v-slot:foot(taxAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'taxAmount')}}</div>
        </template>
      </b-table>
      <!-- <div>{{items}}</div> -->
    </div>
  </div>
</template>

<script>
import {BTable} from 'bootstrap-vue'
import {Decimal} from "decimal.js";


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'materialData', stickyColumn: true, label: '专业名称/规格/单位'},
        {key: 'materialCommonName', label: '常用名称'},
        {key: 'brandName', label: '品牌'},
      ],
      items: [],
      methods: '',
      dataList: [],
      businessId: '',
      wareNumerLabel: '',
      searchForm: {
        deratedId: ''
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      outboundNumTitle: null,
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data.pickingSubs
      this.joint(["materialName", "materialModel", "materialUnit"])
      if (query.data.mode == 2 || query.data.mode == 6) {
        this.fields.push({key: 'applyUsedNum', label: '已经供数量'},{key: 'outboundNum', label: this.outboundNumTitle})
      }
      if (query.data.mode == 4 || query.data.mode == 6) {
        this.fields.push({key: 'includingTaxPrice', label: '含税单价(元)'}, {key: 'amountIncludingTax', label: '含税金额(元)'}, {key: 'taxRate', label: '税率(%)'},{key: 'exincludingTaxPrice', label: '不含税单价(元)'},{key: 'amountExcludingTax', label: '不含税金额(元)'},{key: 'taxAmount', label: '税额(元)'},)
      }
      if (query.data.mode == '1') {
        this.outboundNumTitle = '出库数量';
      } else if (query.data.mode == '2') {
        this.outboundNumTitle = '红冲数量';
      } else if (query.data.mode == '3') {
        this.outboundNumTitle = '盘亏数量';
      }else if (query.data.mode == '4') {
        this.outboundNumTitle = '销售数量';
      }else if (query.data.mode == '6') {
        this.outboundNumTitle = '红冲销售数量';
      }
      this.fields.push( {key: 'exWareCode', label: '出库单'}, {key: 'remarks', label: '备注'})
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

